module.exports = __webpack_public_path__ + "e37fe9ff83ff78ff58584d08bc35a5e1.png";